import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useDropzone } from 'react-dropzone';
import { makeStyles } from '@material-ui/styles';
import { Button, Link, colors, Typography, Avatar } from '@material-ui/core';
import firebase from 'firebase/app';
import 'firebase/storage';
const useStyles = makeStyles(theme => ({
  root: {},
  dropZone: {
    border: `1px dashed ${theme.palette.divider}`,
    padding: theme.spacing(6),
    outline: 'none',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: colors.grey[50],
      opacity: 0.5,
      cursor: 'pointer',
    },
  },
  dragActive: {
    backgroundColor: colors.grey[50],
    opacity: 0.5,
  },
  image: {
    width: 130,
    objectFit: 'cover',
  },
  info: {
    marginTop: theme.spacing(1),
  },
  list: {
    maxHeight: 320,
  },
  actions: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
}));

export async function getImageUrl(logo) {
  if (typeof logo === 'string') {
    const url = await firebase
      .storage()
      .ref()
      .child(logo)
      .getDownloadURL();
    return url;
  } else if (!!logo) {
    return URL.createObjectURL(logo);
  }
  return '';
}

function FilesDropzone({
  className,
  value,
  onChange,
  borderRadius,
  recommendedSize,
  ...rest
}) {
  const classes = useStyles();
  const [logo, setLogo] = useState('');

  React.useEffect(() => {
    getImageUrl(value).then(v => setLogo(v));
  }, [value]);

  const handleDrop = useCallback(
    ([acceptedFiles]) => {
      onChange(acceptedFiles);
    },
    [onChange]
  );

  const handleRemoveAll = () => {
    onChange();
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: handleDrop,
    multiple: false,
    accept: 'image/*',
  });

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <div
        className={clsx({
          [classes.dropZone]: true,
          [classes.dragActive]: isDragActive,
        })}
        {...getRootProps()}
      >
        <input {...getInputProps()} />
        <div>
          {logo ? (
            <Avatar
              src={logo}
              style={{ width: 200, height: 200 }}
              variant={borderRadius}
            />
          ) : (
            <img
              alt="Select file"
              className={classes.image}
              src={'/images/undraw_add_file2_gvbb.svg'}
            />
          )}
        </div>
        <div style={{marginRight:4}}>
          <Typography gutterBottom variant="h3">
            בחירת קובץ
          </Typography>
          <Typography
            className={classes.info}
            color="textSecondary"
            variant="body1"
          >
            ניתן לגרור קבצים לכאן או <Link underline="always">לסייר</Link>{' '}
            בקבצים שעל המחשב
          </Typography>
          {!!recommendedSize && (
            <Typography
              className={classes.info}
              color="textSecondary"
              variant="body1"
            >
              גודל מומלץ:{' '}
              <span style={{ direction: 'rtl' }}>{recommendedSize}</span>
            </Typography>
          )}
        </div>
      </div>
      {logo && (
        <div className={classes.actions}>
          <Button onClick={handleRemoveAll} size="small">
            הסרת התמונה
          </Button>
        </div>
      )}
    </div>
  );
}

FilesDropzone.propTypes = {
  className: PropTypes.string,
};

export default FilesDropzone;
